// MSAL configuration for Microsoft Teams integration
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || 'your-client-id-here',
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

// Scopes needed for Microsoft Graph API
export const loginRequest = {
  scopes: [
    'User.Read',
    'Calendars.Read',
    'OnlineMeetings.Read',  
    'Presence.Read.All',   
  ],
};

// Additional scopes that might be needed
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
  graphCalendarEndpoint: 'https://graph.microsoft.com/v1.0/me/calendar/events',
};